import { InlineMessage } from "@repo/skapa";
import { t } from "@repo/translation";
import { SearchSelect, useOrderedCustomerMeetingPoints } from "@repo/ui";
import { SectionContainer } from "@repo/ui";

import { type ReducerState, type ReducerStateActions } from "./reducer";

export const CmpSelection = ({
  state,
  actions,
}: {
  state: ReducerState;
  actions: ReducerStateActions;
}) => {
  const { data: customerMeetingPoints } = useOrderedCustomerMeetingPoints();

  return (
    <SectionContainer>
      <InlineMessage
        title={t("label.assigned_coworker")}
        body={t("prompt.unassigned_after_changing_cmp")}
        variant="informative"
      />
      <SearchSelect
        localState={state.cmp !== undefined ? [state.cmp] : []}
        onChange={(_, item) => {
          actions.setCmp(item.value);
        }}
        selectionMode="SINGLE"
        values={customerMeetingPoints}
      />
    </SectionContainer>
  );
};
